
import { USER_DATA1 } from "../storage-charge-table/userdata";
export const user_data: USER_DATA1[] = [
    {
        fromDay: 0,
        toDay: undefined,
        tariff: undefined,
        pulse: "Per Day",
        isEdit: true,

    },
];
export const user_data1: USER_DATA1[] = [
    {
        fromDay: 0,
        toDay: undefined,
        tariff: undefined,
        pulse: "Per Day",
        isEdit: true,

    },
];



